import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListadoCamarasComponent } from './listado-camaras/listado-camaras.component';
import { CrearEditarCamaraComponent } from './crear-editar-camara/crear-editar-camara.component';
import { DetallesCamaraComponent } from './detalles-camara/detalles-camara.component';

const routes: Routes = [
  // Camaras - listado por defecto
  {
    path: '',
    title: 'Cámaras',
    component: ListadoCamarasComponent,
    canActivate: [],
  },
  {
    path: 'crear',
    title: 'Nueva cámara',
    component: CrearEditarCamaraComponent,
    canActivate: [],
  },
  {
    path: 'editar/:id',
    title: 'Editar cámara',
    component: CrearEditarCamaraComponent,
    canActivate: [],
  },
  {
    path: 'detalles/:id',
    title: 'Cámara',
    component: DetallesCamaraComponent,
    canActivate: [],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CamarasRoutingModule {}
